import React from 'react';

const TextArea = (props) => {
    const {
        name,
        value,
        onChange,
        required        = false,
        autocomplete    = null,
        autofocus       = null,
        disabled        = false,
        error           = null,
        rows            = null
    } = props;


    return (
        <textarea
            id={name}
            name={name}
            className={!error ? "form-control shadow-none" : "form-control shadow-none is-invalid"}
            value={!!value ? value : ""}
            required={required}
            autoComplete={autocomplete}
            autoFocus={autofocus}
            disabled={disabled}
            rows={rows}
            onChange={(event) => onChange(event.target.value)}
        />
    );
}

export default TextArea;
